import { createAction, props } from '@ngrx/store';
import { VerfahrenResource } from '@schir-int-client/verfahren-shared';
import {
	Kontakt,
	KontaktInVerfahrenListResource,
	KontaktListResource,
	KontaktResource,
	VerfahrenKontakt,
	VerfahrenKontaktResource,
} from './adressverwaltung.model';

const PREFIX = '[Adressverwaltung] ';

export const createKontaktAction = createAction(
	PREFIX + 'Create Kontakt',
	props<{
		kontakt: Kontakt;
	}>()
);

export const createKontaktSuccessAction = createAction(
	PREFIX + 'Create Kontakt Success',
	props<{
		kontakt: KontaktResource;
	}>()
);

export const setKontaktAssignmentAction = createAction(
	PREFIX + 'Set assignment of Kontakt',
	props<{
		verfahrenKontakt: VerfahrenKontakt;
	}>()
);

export const setKontaktAssignmentSuccessAction = createAction(
	PREFIX + 'Set assignment of Kontakt Success',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const loadKontakteByVerfahrenAction = createAction(
	PREFIX + 'Load Kontakte By Verfahren',
	props<{
		verfahren: VerfahrenResource;
	}>()
);

export const loadKontakteByVerfahrenSuccessAction = createAction(
	PREFIX + 'Load Kontakte By Verfahren Success',
	props<{
		kontakte: KontaktInVerfahrenListResource;
	}>()
);

export const searchKontakteAction = createAction(
	PREFIX + 'Search Kontakte',
	props<{
		condition: string;
		filter: string;
		limit: number;
	}>()
);

export const searchKontakteSuccessAction = createAction(
	PREFIX + 'Search Kontakte Success',
	props<{
		owner: string;
		kontakte: KontaktListResource;
	}>()
);

export const updateKontaktAction = createAction(
	PREFIX + 'Update Kontakt',
	props<{
		kontakt: Kontakt;
	}>()
);

export const updateKontaktSuccessAction = createAction(
	PREFIX + 'Update Kontakt Success',
	props<{
		kontakt: KontaktResource;
	}>()
);

export const setSelectedKontaktAction = createAction(
	PREFIX + 'Set Selected Kontakt',
	props<{
		kontakt: KontaktResource;
	}>()
);

export const changeKontaktEditModeAction = createAction(
	PREFIX + 'Change Kontakt Edit Mode',
	props<{
		editMode: boolean;
	}>()
);

export const updateVerfahrenKontaktFreiTextAction = createAction(
	PREFIX + 'Update Verfahren Kontakt Notiz or Aktenzeichen',
	props<{
		verfahrenKontakt: VerfahrenKontaktResource;
	}>()
);

export const updateVerfahrenKontaktFreiTextSuccessAction = createAction(
	PREFIX + 'Update Verfahren Kontakt Notiz or Aktenzeichen Success',
	props<{
		verfahrenKontakt: VerfahrenKontaktResource;
	}>()
);

export function getSearchKontakteOwner(condition: string, filter: string, limit: number) {
	return `${condition};${filter};${limit}`;
}
